import Api from '@/api/api.js'

export default {
    getListeConsultationGroupSection(consultation_id) {
        const promise = Api().get('/consultations/'+consultation_id+'/groupe-sections')
        return promise.then(response => response.data)
    },

    getListeOfActiveGroupSections(data) {
        const promise = Api().post('/consultations/sections/active-groupe', data)
        return promise.then(response => response.data)
    },

    getEvolutionIDInitiale(data) {
        const promise = Api().get('/consultations/consultation-initiale/evolution-id', data)
        return promise.then(response => response.data)
    },

    getDefaultConsultationSections(data) {
        const promise = Api().post('/consultations/default-sections', data)
        return promise.then(response => response.data)
    },

    saveConsultationEvolution(data) {
        const promise = Api().post('/consultations/store/evolution', data)
        return promise.then(response => response.data)
    },

    saveConsultationSection(data) {
        const promise = Api().post('/consultations/store/section', data)
        return promise.then(response => response.data)
    },

    getCurrentConsultationEvolution(consultation_id) {
        const promise = Api().get('/consultations/'+consultation_id+'/current-evolution')
        return promise.then(response => response.data)
    },

    saveConsultationSectionOrder(data) {
        const promise = Api().post('/consultations/save-order/section', data)
        return promise.then(response => response.data)
    },
}